module.exports = __webpack_public_path__ + "img/joeb.9c9fe0af.png";